<template>
  <div class="game-not-found dark">
    <div class="form mw-64 text-left">

      <div class="form__fields">
        <h1 v-html="'Увы, игра не&nbsp;найдена...'"></h1>

        <p>
          Возможно игра уже прошла,
          или вы неправильно ввели код подключения к игре
        </p>

        <div class="image__magnifier"></div>
      </div>

      <div class="form__controls">
        <button
          class="button light wide"
          v-on:click="gotoPincode"
        >Попробовать снова</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GameNotFound',

  props: ['data', 'meta'],

  methods: {
    gotoPincode() {
      this.$emit('event', { event: 'switch-to-pincode' });
    },
  },
};
</script>
